export default __webpack_public_path__ + "static/media/acceY.bb179dac.svg";